import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Novo pedido {{method}}!',
        scheduled: 'Pedido {{method}} agendado!',
      },
      labels: {
        today: 'hoje',
        time_remaining_to_accept: 'restantes para aceitar',
      },
      time_tag: {
        asap: '🕓 Recolha em {{time}}',
        scheduled: '🕓 Recolha {{day}} às {{time}}',
      },
      time_tag_estimated: {
        asap: '🕓 Estimativa de recolha: {{time}}',
        scheduled: '🕓 Estimativa de recolha: {{day}} às {{time}}',
      },
      buttons: {
        confirm_order: 'Confirmar pedido',
        cancel_order: 'Cancelar pedido',
      },
      feedback: {
        rough_estimate_warning:
          'Esta é apenas uma estimativa aproximada. Receberá o tempo de preparação real quando um estafeta for atribuído e o tempo de entrega confirmado. Nesse momento, o talão será impresso automaticamente.',
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Tempo de preparação',
      labels: {
        today: 'Hoje',
        order_time: {
          delivery: {
            asap: 'Entrega em',
            scheduled: 'Entrega a',
          },
          other: {
            asap: 'Recolha em',
            scheduled: 'Recolha a',
          },
        },
        can_you_make_it: 'Consegue cumprir?',
        we_also_send_this_update_to_the_customer: 'Enviamos também esta atualização ao cliente',
      },
      buttons: {
        yes_lets_go: 'Sim, vamos!',
        no_change_time: 'Não, alterar hora',
        confirm: 'Confirmar',
      },
      toasts: {
        order_confirmed: {
          title: 'Pedido #{{number}} confirmado',
          body: 'Não prepare ainda! Avisaremos quando um estafeta for atribuído.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          'Infelizmente, a entrega tem de ser cancelada porque o estafeta não está disponível. Clique nos três pontos no canto superior direito para cancelar o pedido e reembolsar o cliente.',
        [BackendErrorCode.DeliveryProviderException]:
          'Infelizmente, a entrega tem de ser cancelada porque o estafeta não está disponível. Clique nos três pontos no canto superior direito para cancelar o pedido e reembolsar o cliente.',
      },
    },
  },
};
